import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ModalTextContent = ({ children, ...props }) => {
  return (
    <div className={styles.wrapper} {...props}>
      {children}
    </div>
  );
};

ModalTextContent.propTypes = {
  children: PropTypes.node,
};

export default ModalTextContent;
